// Admin → Content — layout route.
//
// `_authed.content.lessons.$id` nests under this file, so it MUST render an
// <Outlet/> or the child never mounts. Before 2026-08-15 this file was both the
// layout AND the curriculum tree with no Outlet, so /content/lessons/$id
// rendered the tree instead of the lesson editor. The tree now lives in
// `_authed.content.index.tsx`.
//
// Same bug and same fix as `_authed.pages.tsx` (M4).

import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/content')({
  component: () => <Outlet />,
});
